import { HANS_COMPANY_ID, STA_COMPANY_ID } from '../../helper/companyIdhardcode'

const lt = (translations) => translations?.lrTrackingPopup || {}

export const getMainTabLabels = (translations) => {
  const t = lt(translations)
  return [t.lrDetails || 'LR DETAILS', t.lrTracking || 'LR TRACKING']
}

export const getPayeeConsignmentTabLabels = (translations) => {
  const t = lt(translations)
  return [t.payeeDetails || 'PAYEE DETAILS', t.consignmentDetails || 'CONSIGNMENT DETAILS']
}

export const getHorizontalTabLabels = (translations) => {
  const t = lt(translations)
  return [
    t.lrTracking || 'LR TRACKING',
    t.lrDetails || 'LR DETAILS',
    t.consignmentDetails || 'CONSIGNMENT DETAILS',
  ]
}

export const isHorizontalLrTracing = (companySettings) =>
  Number(companySettings?.LrTrackingPortrait) === 1
  

export const getTrackCardLabels = (translations) => {
  const t = lt(translations)
  return {
    dateAndTime: t.dateAndTime || 'Date and Time',
    source: t.source || 'Source',
    destinationCity: t.destinationCity || 'Destination City',
    sourceBranch: t.sourceBranch || 'Source Branch',
    destinationBranch: t.destinationBranch || 'Destination Branch',
    bookedByUser: t.bookedByUser || 'Booked By User',
    dispatchedFrom: t.dispatchedFrom || 'Dispatched From',
    dispatchedTo: t.dispatchedTo || 'Dispatched To',
    dispatchedFromBranch: t.dispatchedFromBranch || 'Dispatched From Branch',
    dispatchedToBranch: t.dispatchedToBranch || 'Dispatched To Branch',
    dispatchedByUser: t.dispatchedByUser || 'Dispatched By User',
    dispatchedInVehicle: t.dispatchedInVehicle || 'Dispatched in Vehicle',
    driverName: t.driverName || 'Driver Name',
    driverNumber: t.driverNumber || 'Driver Number',
    shortReceived: t.shortReceived || 'Short Received',
    byUser: t.byUser || 'By User',
    back: t.back || 'Back',
    backToCity: t.backToCity || 'Back To City',
    backFromCity: t.backFromCity || 'Back from City',
    backToBranch: t.backToBranch || 'Back To Branch',
    backFromBranch: t.backFromBranch || 'Back from Branch',
    transferFrom: t.transferFrom || 'Transfer From',
    transferredTo: t.transferredTo || 'Transferred To',
    transferFromBranch: t.transferFromBranch || 'Transfer From Branch',
    transferredToBranch: t.transferredToBranch || 'Transferred To Branch',
    transferredByUser: t.transferredByUser || 'Transferred By User',
    transferredByVehicle: t.transferredByVehicle || 'Transferred By Vehicle',
    dispatchedBy: t.dispatchedBy || 'Dispatched By',
    receivedBy: t.receivedBy || 'Recived By',
    dispatchedByBranch: t.dispatchedByBranch || 'Dispatched By Branch',
    receivedByBranch: t.receivedByBranch || 'Received By Branch',
    receivedByUser: t.receivedByUser || 'Received By User',
    transferredAt: t.transferredAt || 'Transferred At',
    transferReceivedAtBranch: t.transferReceivedAtBranch || 'Transfer Received At Branch',
    transferReceivedByVehicle: t.transferReceivedByVehicle || 'Transfer Received By Vehicle',
    transferReceivedByUser: t.transferReceivedByUser || 'Transfer Received By User',
    deliveredAt: t.deliveredAt || 'Delivered at',
    recipientName: t.recipientName || 'Recepient Name',
    deliveredByBranch: t.deliveredByBranch || 'Delivered by Branch',
    recipientNumber: t.recipientNumber || 'Recepient Number',
    deliveredBy: t.deliveredBy || 'Delivered By',
    deliveryVehicle: t.deliveryVehicle || 'Delivery Vehicle',
    remark: t.remark || 'Remark',
    lost: t.lost || 'Lost',
    markedAsLostByUser: t.markedAsLostByUser || 'Marked as Lost By User',
    destination: t.destination || 'Destination',
    transactionByUser: t.transactionByUser || 'Transaction By User',
    branchTransfer: t.branchTransfer || 'Branch Transfer',
    scTrReceive: t.scTrReceive || 'Sc. Tr. Receive',
    assignDelivery: t.assignDelivery || 'Assign Delivery',
    pendingOutDelivery: t.pendingOutDelivery || 'Pending Out Delivery',
    edit: t.edit || 'Edit',
    save: t.save || 'Save',
    searchByCity: t.searchByCity || 'Search By City',
    searchByBranch: t.searchByBranch || 'Search By Branch',
    searchBy: t.searchBy || 'Search By',
  }
}

export const getStaStatusLabel = (status, translations) => {
  const t = lt(translations)
  if (status === 'Transfered') return t.branchTransfer || 'Branch Transfer'
  if (status === 'Br. Tr. Received') return t.scTrReceive || 'Sc. Tr. Receive'
  if (status === 'Out for Delivery') return t.assignDelivery || 'Assign Delivery'
  if (status === 'Out-Delivered') return t.pendingOutDelivery || 'Pending Out Delivery'
  return status
}

export const getHamaliChargeLabel = (translations, intCompanyID) => {
  const t = lt(translations)
  return intCompanyID === STA_COMPANY_ID
    ? t.hamaliAndToPayCharge || 'Hamali and ToPay Charge'
    : t.hamaliAndOperatorHamali || 'Hamali and Operator Hamali'
}

export const getPickupCartageLabel = (translations, intCompanyID) => {
  const t = lt(translations)
  return [HANS_COMPANY_ID].includes(intCompanyID)
    ? t.crossing || 'Crossing'
    : t.pickupCartage || 'Pickup Cartage'
}

export const getValuationLabel = (translations, defaultCurrencyID) => {
  const t = lt(translations)
  return defaultCurrencyID === 2
    ? t.insuranceCharge || 'Insurance Charge'
    : t.valuationCharge || 'Valuation Charge'
}

export const getRateSuffix = (translations, isUnitBilled) => {
  const t = lt(translations)
  return isUnitBilled ? t.perUnit || ' Per UNIT' : t.perKg || ' Per KG'
}
